import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Megaphone, BarChart3 } from 'lucide-react';

/**
 * Shared segmented nav so Campaigns and Campaign Analytics feel like one hub.
 * Purely navigational — it does not remount either page's data logic (each route
 * still owns its own fetching/polling), so there's zero regression risk.
 */
export default function CampaignsTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const onAnalytics = pathname.startsWith('/campaigns/analytics');

  const tabs = [
    { key: 'campaigns', label: 'Campaigns', icon: Megaphone, to: '/campaigns', active: !onAnalytics },
    { key: 'analytics', label: 'Analytics', icon: BarChart3, to: '/campaigns/analytics', active: onAnalytics },
  ];

  return (
    <div className="inline-flex items-center gap-1 rounded-lg border bg-muted/40 p-1" data-testid="campaigns-hub-tabs">
      {tabs.map(({ key, label, icon: Icon, to, active }) => (
        <button
          key={key}
          type="button"
          onClick={() => { if (!active) navigate(to); }}
          data-testid={`campaigns-hub-tab-${key}`}
          className={`inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
            active
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          <Icon className="h-4 w-4" /> {label}
        </button>
      ))}
    </div>
  );
}
